import { j as e } from "../../../_virtual/jsx-runtime.js";
import a from "../SkeletonWrapper/index.js";
import { getTagStyles as c, getIconSize as m } from "./styles.js";
import { cn as d } from "../../../lib/utils.js";
import g from "../Icon/index.js";
const C = (s) => {
  const { label: r, iconProps: i, onClick: n, isLoading: t } = s, o = c(s), l = m(s.size || "sm");
  return /* @__PURE__ */ e.jsx(a, { isLoading: t, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: d(
        o.base,
        o.size,
        o.rounded,
        o.bgColor,
        o.disabled,
        s.className
      ),
      ...!o.bgColor && { style: { backgroundColor: s.bgColor } },
      onClick: n,
      children: [
        /* @__PURE__ */ e.jsx(g, { ...i, ...l }),
        /* @__PURE__ */ e.jsx("span", { children: r })
      ]
    }
  ) });
};
export {
  C as default
};
